import script from "./One_comment.vue?vue&type=script&setup=true&lang=ts"
export * from "./One_comment.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__